import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import MaterialIcon from '../icon/MaterialIcon';

import layout from '../../../app/layout';

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
`;

const Count = styled.div`
  background: ${layout.sidebar.count.background};
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Link = styled.span`
  align-self: center;
  font-size: 14px;
  color: ${(props) => props.theme.mediumGray};

  &.active,
  &:hover {
    color: ${layout.sidebar.item.active.color};
    fill: ${layout.sidebar.item.active.color};
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  cursor: pointer;
`;

type Props = {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  route: string;
  count?: number;
};

const AsideMenuItem = ({
  action,
  route,
  closeMenu,
  icon,
  title,
  count,
  ...rest
}: Props) => {
  const history = useHistory();

  const handleClick = () => {
    if (!!closeMenu) {
      closeMenu();
    }

    if (!!action) {
      return action();
    }

    history.push(route);
  };

  return (
    <Wrapper onClick={handleClick} {...rest}>
      {!!icon && (
        <Icon>
          <MaterialIcon fontSize={10} color="white">
            {icon}
          </MaterialIcon>
        </Icon>
      )}
      <Link>{title}</Link>
      {count !== null && count !== undefined && <Count>{count}</Count>}
    </Wrapper>
  );
};

export default AsideMenuItem;
